import { createFileRoute } from '@tanstack/react-router';

import {
  ShipmentHistoryPage,
  validateHistorySearch,
} from '../../features/shipment-history';

export const Route = createFileRoute('/_app/history')({
  staticData: { crumbs: ['История отгрузок'] },
  // Фильтры, сортировка и страница живут в адресной строке - валидируем их здесь.
  validateSearch: validateHistorySearch,
  component: ShipmentHistoryPage,
});
